import React from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';
import styled from 'styled-components';
// import routes, { routeFor } from 'helpers/routes';
// import { BlogType } from 'types';
import { theme } from 'styles';

const StyledBlogCard = styled(Link)`
  transition: all 0.3s;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  border-radius: 6px;
  box-shadow: ${theme.boxShadow.small};
  background-color: ${theme.colors.white};
  width: 100%;
  font-size: 16px;
  line-height: 20px;
  color: ${theme.colors.navy};
  text-decoration: none;

  &:hover {
    box-shadow: ${theme.boxShadow.big};
  }

  ${props =>
    props.whitepaper &&
    `
    color: ${theme.colors.royal};
  `};
`;

const Image = styled.div`
  display: block;
  border-radius: 6px 6px 0px 0px;
  background-size: cover;
  background-position: center top;
  background-image: url('${props => props.src}');
  background-repeat: no-repeat;
  padding-bottom: 215px;
  width: 100%;
  height: 0;
`;

const Name = styled.div`
  display: block;
  font-size: 24px;
  line-height: 29px;
  font-weight: 500;
`;

const DetailWrapper = styled.div`
  padding: 20px 40px;
  height: 150px;
`;

const Cta = styled.div`
  margin: 0 40px 20px;
  font-size: 16px;
  line-height: 16px;
  color: ${theme.colors.blue};

  ${props =>
    props.whitepaper &&
    `
    margin: 0 auto 60px;
  `};
`;

function BlogCard(props) {
  return (
    <StyledBlogCard to={`/tapd-in/${props.post.slug}`} {...props}>
      <Image
        src={props.post.headerBackgroundImage.responsiveResolution.src}
        alt={props.post.heading}
      />
      <DetailWrapper>
        <Name>{props.post.heading}</Name>
      </DetailWrapper>
      <Cta {...props}>Read More</Cta>
    </StyledBlogCard>
  );
}

BlogCard.propTypes = {
  post: PropTypes.node.isRequired,
};

export default BlogCard;



// WEBPACK FOOTER //
// ./src/components/shared/BlogCard/BlogCard.jsx